import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Box
} from '@mui/material';
import { Target, Brain, TrendingUp, Zap, Award } from 'lucide-react';
import getStyles from './styles';

const ProblemSection = () => {
  const styles = getStyles();

  const problems = [
    {
      icon: Target,
      text: 'Students struggle to get real-world exposure beyond theory.'
    },
    {
      icon: Brain,
      text: "Aspirants don't get actual product experience, only tasks."
    },
    {
      icon: TrendingUp,
      text: 'Too many programs produce job seekers, not leaders.'
    },
    {
      icon: Zap,
      text: 'Talented people lack environments where they can build, not just learn.'
    },
    {
      icon: Award,
      text: 'No platform gives young people ownership, real deadlines, customer interaction, or market responsibility.'
    }
  ];

  return (
    <Grid sx={styles.section}>
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            Why This Fellowship? <br />
            <span style={styles.primaryText}>
              Because Opportunities Aren&apos;t Equal - But Potential Is
            </span>
          </Typography>
          <Grid sx={styles.cardsContainer}>
            {problems.map((item, idx) => (
              <Card key={idx} sx={styles.card}>
                <CardContent sx={styles.cardContent}>
                  <Box sx={styles.cardIcon}>
                    <item.icon />
                  </Box>
                  <Typography sx={styles.cardText}>{item.text}</Typography>
                </CardContent>
              </Card>
            ))}
          </Grid>
          {/* <Typography sx={styles.quote}>
            Today&apos;s youth have talent… but not the environment to turn it
            into leadership. This fellowship fixes that.
          </Typography> */}
        </Grid>
      </Container>
    </Grid>
  );
};

export default ProblemSection;
